import { EnvironmentType } from "@env/EnvironmentType";

export const environment: EnvironmentType = {
  production: false,
  testSystem: false,
  apiHostname: "api",
  wsHostname: "wss://turnportal-stg.digiturndev.net/ws",
  licenceExtensionAllowedFrom: { month: 9, day: 1 },
};
